import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { UserService, AlertService } from '@app/_services';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-password-reset-request',
    templateUrl: './password-reset-request.component.html',
    styleUrls: ['./password-reset-request.component.css'],
    providers: [MessageService],
    standalone: false
})
export class PasswordResetRequestComponent
{
    /**
     * Inspired from https://blog.thoughtram.io/angular/2017/11/13/easy-dialogs-with-angular-material.html
     */

	form1: UntypedFormGroup;
	formSubmitted = false;
	formLoading = false;
	formErrorMessage: string;
	showResetForm = true;
	showResetConfirm = false;


	constructor(
		private formBuilder: UntypedFormBuilder,
		private router: Router,
		private userService: UserService,
		private alertService: AlertService,
		private messageService: MessageService
	) { }

	validationMessages =
		{
			email: [
				{ type: 'required', message: 'Email is required' },
				{ type: 'email', message: 'Enter a valid email address' }
			]
		};


	// sourceUrl is used by the api to create the correct link to click to reply to reset email.
	// tslint:disable-next-line:use-lifecycle-interface
	ngOnInit()
	{
		this.formBuild();
	}

	onPasswordResetRequestSubmit()
	{
		// stop here if form is invalid
		if (this.form1.invalid)
		{
			return;
		}
		this.formLoading = true;
		this.userService.resetPasswordRequest(this.form1.value)
			.pipe(first())
			.subscribe(
				data =>
				{
					console.log('password-reset-request.component SUCCESS: ' + JSON.stringify(data));
					this.showResetConfirm = true;
					this.showResetForm = false;
				},
				err =>
				{
					console.log('error in password-reset-request.component: ' + JSON.stringify(err));
					this.formErrorMessage = err.error.message
					// this.messageService.add({ severity: 'error', summary: 'Reset Failed', detail: 'We were unable to process your password reset request, please try again.', sticky: true });
					this.formLoading = false;
				},
				() => { this.formLoading = false; });


		console.log(this.form1.value.email);
	}

	formBuild()
	{
		this.form1 = this.formBuilder.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.email
			])],
		});
	}
}
